<template>
  <div
    class="con-wrap"
    v-loading="lockStatus"
    element-loading-text="数据加载中......"
    element-loading-spinner="el-icon-loading"
  >
    <div class="options-wrap">
      <div class="option-box fl">
        <span>请选择每排展示画面的个数: </span>
        <i class="el-icon-menu" @click="changeArrangement(2)"></i>
        <i class="el-icon-s-grid" @click="changeArrangement(3)"></i>
      </div>
      <img class="fr backBtn" src="../../assets/images/GIS/fanhui.png" alt="" @click="$router.go(-1)">
    </div>
    <div class="bottom-box">
      <corner-box class="left-box fl box-element">
        <div class="title-box">选择要展示的摄像头</div>
        <el-tree
          class="tree-box"
          :data="treeList"
          node-key="id"
          ref="tree"
          show-checkbox
          default-expand-all
          :props="defaultProps"
          :default-checked-keys="defaultCheckedTreeKey">
        </el-tree>
        <div class="btn-box">
          <el-button class="fr" @click="query()" >确认</el-button>
        </div>
      </corner-box>
      <corner-box class="right-box fl box-element">
        <div v-for="item in videoData" class="clear video-wrap" :key="item.id">
          <p class="company-name">{{item.name}}</p>
          <template v-if="item.children">
            <div :class="[`video-box${arrangement}`, 'fl']" v-for="node in item.children" :key="node.id">
              <!-- 视频窗口 -->
              <video
                  :id="'myPlayer' + node.id"
                  :src="node.m3u8Address"
                  controls
                  playsInline
                  webkit-playsinline
                  autoplay
                  muted>
              </video>
              <div class="video-title">{{node.name}}</div>
            </div>
          </template>
          <div class="no-data" v-else>
            暂无视频监控画面
          </div>
        </div>
      </corner-box>
    </div>
  </div>
</template>

<script>
import * as EZUIKit from "../../assets/js/external/ezuikit";
import cornerBox from "../../components/cornerBox";
export default {
  name: "videoMonitoring",
  components:{
    cornerBox
  },
  data() {
    return {
      lockStatus: false,
      videoData: {},
      treeList: [],
      defaultCheckedTreeKey: [],
      defaultProps:{children: 'children',label: 'name'},
      arrangement: 2,
      allKeys: [],  //全部父节点
    };
  },
  mounted() {
    this.getTree();
  },
  beforeDestroy() {
    this.videoData = [];
  },
  watch: {
    $route(newValue) {
      this.getTree();
      this.getVideo();
    },
    videoData(val) {
      this.$nextTick(function() {
        for(let i in this.videoData){
          let videoNode = this.videoData[i].children;
          if(videoNode){
            for(let node in videoNode) {
              let now = new EZUIKit.EZUIPlayer("myPlayer" + videoNode[node].id);
              now.on("play", function () {
              });
              now.on("error", function () {
                console.log("error");
              });
            }
          }
        }
      });
    }
  },
  methods: {
    getTree() {
      this.$get("videomonitoring/getdivisionvediobyassetnumber", ['0','0']).then(response => {
        this.treeList = response;
        for( let i in response) {
          this.allKeys.push(response[i].id);
        }
        this.getVideo( response[0].id );
      })
      .catch(response => {
        console.log(response);
      });
    },
    getVideo( id ) {
      let param1 = [];
      this.defaultCheckedTreeKey = [];
      if( this.$route.query.id || id){
        param1.divisionId = this.$route.query.id ? this.$route.query.id : id;
        this.defaultCheckedTreeKey.push( param1.divisionId );
      } else {
        param1.divisionId = '0';
        this.defaultCheckedTreeKey = this.allKeys;
      }
      param1.assetNumber = '0';
      this.$get("videomonitoring/getdivisionvediobyassetnumber", param1).then(response => {
        this.videoData = response;
      })
      .catch(response => {
        console.log(response);
      });
    },
    query() {
      let param = [];
      let arr1 = this.$refs.tree.getCheckedKeys();        //选中的节点
      let halfNode = this.$refs.tree.getHalfCheckedNodes();
      let checkedParents = [];
      if(halfNode.length != 0){
        for(let i in halfNode){
          let nowHalfNodeId = halfNode[i].id;
          checkedParents.push(nowHalfNodeId)
        }
      }
      for( let key1 in arr1 ){
        for( let key2 in this.allKeys ) {
          if ( arr1[key1] === this.allKeys[key2]){
            checkedParents.push(arr1[key1])
            arr1.splice(key1,1);
          }
        }
      }
      param.divisionId = checkedParents.join(',');
      param.assetNumber = arr1.join(',');
      if( param.assetNumber ){
        this.$get("videomonitoring/getdivisionvediobyassetnumber", param).then(response => {
          this.videoData = response;
          this.changeArrangement( this.arrangement );
        })
        .catch(response => {
          console.log(response);
        });
      }
    },
    changeArrangement(num) {
      this.arrangement = num;
      let two = document.querySelector(".el-icon-menu");
      let three = document.querySelector(".el-icon-s-grid");
      if( num === 3 ){
        two.style.color = "#d8d8d8";
        three.style.color = "#198dff";
      } else {
        two.style.color = "#198dff";
        three.style.color = "#d8d8d8";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.con-wrap {
  width: 100%;
  padding-top: 10px;
  min-width: 1315px;
  /*overflow-x: scroll;*/
  .options-wrap {
    display: table;
    width: 99%;
    margin: auto;
    line-height: 46px;
    font-size: 14px;
    color: #000;
    .option-box {
      margin-left: 10px;
      span {
        margin-right: 20px;
        color: #fff;
      }
      i {
        margin-right: 10px;
        cursor: pointer;
        color: #198dff;
      }
      i:last-child {
        color: #d8d8d8;
      }
    }
    .backBtn{
      margin-right: 25px;
      width: 30px;
      height: 30px;
      cursor: pointer;
    }
  }
  .bottom-box {
    overflow: hidden;
    height: 100%;
    .left-box {
      width: 18%;
      /*min-width: 221px;*/
      height: 730px;
      margin: 0 10px;
      .title-box{
        padding: 10px;
        font-size: 16px;
        //color: $light;
        @include font_color("font_color1")
      }
      .tree-box {
        height: 620px;
        overflow: auto;
        //color: $light;
        @include font_color("font_color1")
      }
      .btn-box {
        width: 100%;
        margin-top: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .right-box {
      width: 80%;
      min-width: 1000px;
      height: 730px;
      overflow-y: scroll;
      overflow-x: hidden;
      .video-wrap{
        width: 100%;
        //background: #012135b0;
        margin-bottom: 10px;
      }
        .company-name{
          /*background: #011525fc;*/
          height: 45px;
          line-height: 45px;
          //color: $positive;
          color: #198DFF;
          padding-left: 20px;
          font-size: 16px;
          letter-spacing: 2px;
        }
        .no-data{
          height: 200px;
          line-height: 150px;
          width: 100%;
          color: $light;
          text-align: center;
          font-size: 25px;
          letter-spacing: 2px;
        }
      .video-box2 {
        display: inline-block;
        width: 49%;
        margin: 0.5%;
        padding: 10px;
        border: 1px solid #032946;
        video {
          width: 100%;
          height: 366px;
          border: 1px solid #032946;
        }
        .video-title {
          line-height: 30px;
          font-size: 15px;
          text-align: center;
          color: $light;
          // color: #000;
        }
      }
      .video-box3 {
        display: inline-block;
        width: 32%;
        margin: 0.5%;
        padding: 10px;
        border: 1px solid  #032946;
        video {
          width: 100%;
          height: 300px;
          border: 1px solid  #032946;
        }
        .video-title {
          line-height: 30px;
          font-size: 15px;
          text-align: center;
          // color: #000;
          color: $light;
        }
      }
    }
  }
}
</style>
